/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const InvitationStatus = zod.enum(['pending', 'accepted', 'revoked', 'expired']);

export type InvitationStatus = zod.input<typeof InvitationStatus>;
export type InvitationStatusOutput = zod.output<typeof InvitationStatus>;
